module.exports = __webpack_public_path__ + "img/signature_electronique.28ceea5a.png";